import { Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { Seo, SeoData } from './shared/services/seo';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly seo = inject(Seo);

  constructor() {
    // Runs on the server during SSR/prerendering too, which is what puts
    // per-route title/meta/canonical tags into the static HTML.
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.deepestRoute(this.activatedRoute)),
        mergeMap((route) => route.data),
      )
      .subscribe((data) => {
        const seoData = data['seo'] as SeoData | undefined;
        if (seoData) {
          this.seo.apply(seoData);
        }
      });
  }

  private deepestRoute(route: ActivatedRoute): ActivatedRoute {
    let current = route;
    while (current.firstChild) {
      current = current.firstChild;
    }
    return current;
  }
}
